import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router';
import { ConsoleLayout } from './layouts';
import {
    BareMetalComputePage,
    CloudComputeInstancePage,
    CloudComputePage,
    ContainerEnginePage,
} from './pages';
import BillingsPage from './pages/private/account/BillingsPage/BillingsPage';
import ProfilePage from './pages/private/account/ProfilePage/ProfilePage';
import ProjectDetailPage from './pages/private/account/ProjectDetailPage/ProjectDetailPage';
import ProjectsPage from './pages/private/account/ProjectsPage/ProjectsPage';
import SecurityPage from './pages/private/account/SecurityPage/SecurityPage';
import SSHKeysPage from './pages/private/account/SSHKeysPage/SSHKeysPage';
import CouponPage from './pages/private/platform/CouponPage/CouponPage';
import SettingsPage from './pages/private/platform/SettingsPage/SettingsPage';
import TopupPage from './pages/private/platform/TopupPage/TopupPage';
import ArtifactRegistryPage from './pages/private/product/ArtifactRegistryPage/ArtifactRegistryPage';
import BareMetalComputeDeploymentPage from './pages/private/product/BareMetalComputeDeploymentPage/BareMetalComputeDeploymentPage';
import BareMetalComputeInstancePage from './pages/private/product/BareMetalComputeInstancePage/BareMetalComputeInstancePage';
import BlockStoragePage from './pages/private/product/BlockStoragePage/BlockStoragePage';
import CloudComputeDeploymentPage from './pages/private/product/CloudComputeDeploymentPage/CloudComputeDeploymentPage';
import CloudComputeSecurityGroupPage from './pages/private/product/CloudComputeSecurityGroupPage/CloudComputeSecurityGroupPage';
import ContainerEngineDeploymentPage from './pages/private/product/ContainerEngineDeploymentPage/ContainerEngineDeploymentPage';
import ContainerEngineInstancePage from './pages/private/product/ContainerEngineInstancePage/ContainerEngineInstancePage';
import DashboardPage from './pages/private/product/DashboardPage/DashboardPage';
import { ApplicationState } from './store';

export default function Root() {
    const user = useSelector((state: ApplicationState) => state.auth.user);

    return (
        <ConsoleLayout user={user}>
            <Routes>
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/cloud-compute" element={<CloudComputePage />} />
                <Route path="/cloud-compute/deployment" element={<CloudComputeDeploymentPage />} />
                <Route
                    path="/cloud-compute/security-groups/:sgId"
                    element={<CloudComputeSecurityGroupPage />}
                />
                <Route path="/cloud-compute/:instanceId" element={<CloudComputeInstancePage />} />
                <Route path="/bare-metal-compute" element={<BareMetalComputePage />} />
                <Route
                    path="/bare-metal-compute/deployment"
                    element={<BareMetalComputeDeploymentPage />}
                />
                <Route
                    path="/bare-metal-compute/:baremetalId"
                    element={<BareMetalComputeInstancePage />}
                />
                <Route path="/container-engine" element={<ContainerEnginePage />} />
                <Route
                    path="/container-engine/deployment"
                    element={<ContainerEngineDeploymentPage />}
                />
                <Route
                    path="/container-engine/:containerId"
                    element={<ContainerEngineInstancePage />}
                />
                <Route path="/block-storage" element={<BlockStoragePage />} />
                <Route path="/artifact-registry" element={<ArtifactRegistryPage />} />
                <Route path="/account/profile" element={<ProfilePage />} />
                <Route path="/account/security" element={<SecurityPage />} />
                <Route path="/account/billings" element={<BillingsPage />} />
                <Route path="/projects" element={<ProjectsPage />} />
                <Route path="/projects/:projectId" element={<ProjectDetailPage />} />
                <Route path="/ssh-keys" element={<SSHKeysPage />} />
                <Route path="/platform/topup" element={<TopupPage />} />
                <Route path="/platform/coupon" element={<CouponPage />} />
                <Route path="/platform/settings" element={<SettingsPage />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
        </ConsoleLayout>
    );
}
